// @ts-ignore
import {WorkflowMoreCondition} from '../WorkflowMoreCondition';

export class MoreAboutWorkflow {
  enterpriseName: string;
  enterpriseTradeName: string;
  requiredSieConfig: number;
  sieConfigured: number;
  tenorConfigured: boolean;
  hasTemplate: boolean;
  manageDocumentChecked: boolean;
  workflowMoreCondition: WorkflowMoreCondition;
}
